// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HASHTAGS = "Hashtagy";
export const HASHTAGS_SHOW_ALL = "Zobraz v\u0161echny";
